import { WebCase } from "../../models/cases/WebCase";
 import { WebsiteProblem } from "../DocumentAnalyzer";

export const WEBCASE_FINAL_STATE = "completed";
export const WEBCASE_STATE_FAILED = "failed";
export const WEBCASE_STATE_COOKIES_UNKNOWN_FOUND_REPORTED =
  "unknown_cookies_reported";

  export const workflowDisplayName = (workflowType: string) => {
    switch (workflowType) {
      case "WEB_SECURITY":
        return "IT-Security (Website-Sicherheit)";
      case "WEB_PREMIUM":
        return"Premium (DSGVO + IT-Security)";
          case "WEB_SWISS":
           return "Website-Check Schweiz";
           case "WEB_SWISS_2":
            return "Website-Check Schweiz (light)";
           case "WEB_STANDARD":
            return "DSGVO (Rechtskonformität)";
            default: return workflowType;
    }
  }
export const webcaseType =(webcase:WebCase) : {name: WebcaseWorkflowType; label:string} => {
  if(webcase.workflow_type) {
    switch (webcase.workflow_type)
    {
      case "WEB_SECURITY":
        return {name: "WEB_SECURITY", label: "IT-Security (Website-Sicherheit)"}
      case "WEB_PREMIUM":
        return {name: "WEB_PREMIUM", label: "Premium (DSGVO + IT-Security)"}
          case "WEB_SWISS":
            return {name: "WEB_SWISS", label: "Website-Check Schweiz"}
            case "WEB_SWISS_2":
              return {name: "WEB_SWISS", label: "Website-Check Schweiz"}
    }
  }
    else {
      if(webcase.crawl_depth == "PREMIUM") {
        return {name: "WEB_PREMIUM", label: "Premium (DSGVO + IT-Security)"}
      }
  }
  return {name: "WEB_STANDARD", label: "DSGVO (Rechtskonformität)"}
}
export const WEBCASE_STEPS = {
  WEB_STANDARD: [{
    displayName: "Erstellt",
    statuses: ["created"],
    index: 0,
    icon: "PlusCircleOutlined",
  },
  {
    displayName: "Cookie-Banner",
    statuses: ["banner_detect_requested", "banner_detect_completed"],
    index: 1,
    icon: "ExpandOutlined",
  },
  {
    displayName: "Cookie-Analyse",
    statuses: ["analysis_requested", "analyzed"],
    index: 2,
    icon: "CookieOutlined",
  },
  {
    displayName: "Crawler gestartet",
    statuses: [
      "urls_detecting_requested",
      "urls_detected",
      "crawling_requested",
    ],
    index: 3,
    icon: "FileSearchOutlined",
  },
  {
    displayName: "Analyse läuft",
    statuses: ["crawled", "comparison_requested", "technology_version_check_requested","technology_version_check_completed", "compared"],
    index: 4,
    icon: "NodeIndexOutlined",
  }, 
  {
    displayName: "Analyse abgeschlossen",
    statuses: ["completed"],
    index: 5,
    icon: "CheckCircleOutlined",
  },
],
WEB_PREMIUM: [{
  displayName: "Erstellt",
  statuses: ["created"],
  index: 0,
  icon: "PlusCircleOutlined",
},
{
  displayName: "Cookie-Banner",
  statuses: ["banner_detect_requested", "banner_detect_completed"],
  index: 1,
  icon: "ExpandOutlined",
},
{
  displayName: "Cookie-Analyse",
  statuses: ["analysis_requested", "analyzed"],
  index: 2,
  icon: "CookieOutlined",
},
{
  displayName: "Crawler gestartet",
  statuses: [
    "urls_detecting_requested",
    "urls_detected",
    "crawling_requested",
  ],
  index: 3,
  icon: "FileSearchOutlined",
},
{
  displayName: "Analyse läuft",
  statuses: ["crawled","evaluation_requested", "comparison_requested", "technology_version_check_requested","technology_version_check_completed", "compared"],
  index: 4,
  icon: "NodeIndexOutlined",
}, 
{
  displayName: "Analyse abgeschlossen",
  statuses: ["completed"],
  index: 5,
  icon: "CheckCircleOutlined",
},
],

WEB_SECURITY: [{
  displayName: "Erstellt",
  statuses: ["created"],
  index: 0,
  icon: "PlusCircleOutlined",
},
{
  displayName: "SSL-Check", //ssl check
  statuses: ["banner_detect_requested", "banner_detect_completed", "analysis_requested", "analyzed"],
  index: 1,
  icon: "LockOutlined",
},
{
  displayName: "Crawler & Softwarecheck",
  statuses: [
    "urls_detecting_requested",
    "urls_detected",
    "crawling_requested",
  ],
  index: 2,
  icon: "FileSearchOutlined",
},
{
  displayName: "Analyse läuft",
  statuses: ["crawled",  "comparison_requested", "technology_version_check_requested","technology_version_check_completed", "compared"],
  index: 3,
  icon: "NodeIndexOutlined",
}, 
{
  displayName: "Analyse abgeschlossen",
  statuses: ["completed"],
  index: 4,
  icon: "CheckCircleOutlined",
},
],

WEB_SWISS: [{
  displayName: "Erstellt",
  statuses: ["created"],
  index: 0,
  icon: "PlusCircleOutlined",
},
{
  displayName: "SSL-Check",
  statuses: ["banner_detect_requested", "banner_detect_completed"],
  index: 1,
  icon: "LockOutlined",
},
{
  displayName: "Cookie-Analyse",
  statuses: ["analysis_requested", "analyzed"],
  index: 2,
  icon: "CookieOutlined",
},
{
  displayName: "Crawler gestartet",
  statuses: [
    "urls_detecting_requested",
    "urls_detected",
    "crawling_requested",
  ],
  index: 3,
  icon: "FileSearchOutlined",
},
{
  displayName: "Analyse läuft",
  statuses: ["crawled", "comparison_requested", "technology_version_check_requested","technology_version_check_completed", "compared"],
  index: 4,
  icon: "NodeIndexOutlined",
}, 
{
  displayName: "Analyse abgeschlossen",
  statuses: ["completed"],
  index: 5,
  icon: "CheckCircleOutlined",
},
],
WEB_SWISS_2: [{
  displayName: "Erstellt",
  statuses: ["created"],
  index: 0,
  icon: "PlusCircleOutlined",
},
{
  displayName: "SSL-Check",
  statuses: ["banner_detect_requested", "banner_detect_completed"],
  index: 1,
  icon: "LockOutlined",
},
{
  displayName: "Cookie-Analyse",
  statuses: ["analysis_requested", "analyzed"],
  index: 2,
  icon: "CookieOutlined",
},
{
  displayName: "Crawler gestartet",
  statuses: [
    "urls_detecting_requested",
    "urls_detected",
    "crawling_requested",
  ],
  index: 3,
  icon: "FileSearchOutlined",
},
{
  displayName: "Analyse läuft",
  statuses: ["crawled", "comparison_requested", "technology_version_check_requested","technology_version_check_completed", "compared"],
  index: 4,
  icon: "NodeIndexOutlined",
}, 
{
  displayName: "Analyse abgeschlossen",
  statuses: ["completed"],
  index: 5,
  icon: "CheckCircleOutlined",
},
],

};

export const REPORT_NOTICE =
  "Hinweise/Disclaimer: Der vorhandene Website-Check wird automatisiert erstellt und ersetzt nicht die kritische Prüfung und Interpretation der Ergebnisse durch geschultes Personal. " +
  "Der Website-Check ist eine Momentaufnahme zum Zeitpunkt der Erstellung (siehe Datum und Uhrzeit des Website-Checks). Die dargestellten Ergebnisse können sich aufgrund verschiedener Faktoren (z.B. technische oder inhaltliche Änderungen auf der Webseite, Seitenaufruf mit verschiedenen Geräten oder Browsern, Browser-Historie des Users etc.) ändern. " +
  "Eine regelmäßige Überprüfung der Webseite wird daher empfohlen. Zusätzlich besteht die Möglichkeit, dass Webseitenbetreiber die Überprüfung ihrer Website (technisch) blockieren und das Analyseergebnis daher verfälscht wird. Dementsprechend wird für die Korrektheit der Ergebnisse des Website-Checks keine Haftung übernommen. " +
  "Dieser Report dient ausschließlich zur internen Verwendung für den berechtigten Webseiteninhaber und –betreiber und von diesem berechtigten Personen. Der vorliegende Website-Check stellt in keinster Weise eine rechtliche Beratung dar; für eine juristische Beratung kontaktieren Sie bitte die entsprechenden Experten.";

export const REPORT_ALL_ITEMS = [
  { label: "Deckblatt/Front-Cover", value: "cover" },
  { label: "Zusammenfassung/Inhaltsverzeichnis", value: "summary" },
  { label: "To-Do Liste", value: "todolist" },
  { label: "Technische Details", value: "technical-details" },
  { label: "Cookie-Banner", value: "cookie-banner" },
  { label: "Cookies", value: "cookie-check" },
  { label: "Datenschutzerklärung", value: "dat" },
  { label: "Cookie Richtlinien", value: "cok" },
  { label: "AGB", value: "agb" },
  { label: "Impressum", value: "imp" },
  { label: "Datenverarbeitung via Webformular", value: "forms" },
  { label: "SSL-Zertifikat", value: "ssl" },
  { label: "Extern geladene Inhalte", value: "external-content" },
  { label: "Security Header", value: "security-header" },
  { label: "Software inkl.Versionscheck ", value: "software" },
  { label: "Verschlüsselung", value: "encryption" },
  { label: "Security Flags Cookies", value: "security-flags" },
  { label: "Captcha", value: "captcha" },
  { label: "Telefon/E-Mail sichtbar", value: "phone-email" },
  { label: "Kommentar/Hinweis", value: "comment" },
  { label: "Haftungsausschluss/Disclaimer", value: "disclaimer" },
  { label: "Letzte Seite/Kontaktinformationen", value: "backcover" },
  { label: "Letzte Seite/Kontaktinformationen", value: "backcover" },
 ];


export const CookieBannerNotice = {
  header: "Wichtiger Hinweis",
  text: 'Um das Cookie Banner bereits zukunftsfähig auszurichten, sollte ein Ablehnen der Cookies ebenso einfach erfolgen können wie das Akzeptieren der Cookies ("one click").',
  color: "#e18207",
};
export const SOFTWARE_VERSION_NOTICE = {
  header: "Wichtiger Hinweis",
  text: 'Aktuell werden nur manche Softwarekomponenten bzgl. Aktualität der Version überprüft (siehe Tabelle).',
  color: "#e18207",
}
export const externalLinkNotice = {
  header: "Wichtiger Hinweis",
  text: 'Bitte seien Sie vorsichtig beim Öffnen der angezeigten Links; v.a. beim Laden von Applikationen besteht ein Sicherheitsrisiko!',
  color: "#e18207",
}
export const externalContentNotice = {
  header: "Wichtiger Hinweis",
  text: 'Die Überprüfung von extern geladenen Inhalten wurde nur auf der Startseite der Webseite durchgeführt. Auf Unterseiten kann das Ergebnis abweichen.',
  color: "#e18207",
};
export const technicalDetailsNotice = {
  header: "Wichtiger Hinweis",
  text: 'Es werden nur die auf der Startseite zugänglichen Links gezählt & externe Links herausgefiltert.',
  color: "#e18207",
};
export type WebsiteCheckItems = "externalContent" | "forms" | "software" | "cookieBanner" |"cookieCheck" | "dat"
| "ssl" | "securityFlags" | "technicalDetails" | "cok" | "agb" | "imp" | "captcha" | "headers" | "phoneEmail" | "encryption";

export const WEBSITE_CHECK_INFO : {[key in WebcaseWorkflowType]: {[key in WebsiteCheckItems] : {content:string;header:string} | null} } = {
  WEB_STANDARD: {
    encryption:null,
    securityFlags:null,
    technicalDetails:null,
    
  externalContent: {
    content: `<p>Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten: </p>
    <p>- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.  </p>
    <p>- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen. </p>
    <p>- Unerlaubte Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). Dies kann potenziell eine Verletzung der DSGVO und anderer Datenschutzregelungen bedeuten. </p>
    <p>- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.</p>
    <p>Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).</p>`,
    header : ""

  },
  cookieBanner: {
    content: `
  <p>Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. </p>
  <p>Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. </p>
    <p>Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.</p>
      <p>Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. </p>

  `,
    header: "",
  },
  cookieCheck: {
    content: `
    <p>Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: </p>
        <p><strong><i>Funktionale (technisch notwendige) Cookies: </i></strong>z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security. Diese Cookies dürfen ohne Zustimmung des Webseitenbesuchers aktiviert werden.</p>
            <p><strong><i>Nicht technisch notwendige Cookies: </i></strong>z.B. für Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics. Diese Cookies dürfen erst nach Zustimmung des Webseitenbesuchers aktiviert werden.</p>
    <p>Alle Cookies sollen zusätzlich in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). </p>
  `,
    header: "",
  },
  dat: {
    content: `
  <p><u>Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert. Der Webseitenbesucher muss zusätzlich auch über seine Rechte aufgeklärt werden (z.B. Recht auf Löschung, Widerruf, Widerspruch oder Beschwerde). </p>
    <p>V.a. die Verarbeitung von Daten in Drittstaaten (Länder außerhalb der EU) ist mitunter problematisch. Dies betrifft z.B. die Aktivierung von nicht technisch notwendigen Cookies von US-Anbietern (wie z.B. Google Analytics/YouTube von Google oder Facebook Ads von Meta). Die Gesetzeslage ist hier sehr dynamisch und ändert sich relativ häufig; zur konkreten Abklärung wird die Beratung durch einen zugelassenen Rechtsanwalt empfohlen. </p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). </p>

  `,
    header: "",
  },
  cok: {
    content: ` <p><u>Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).</p>`,
    header: "",
  },
  agb: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. </p>
  <p>Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. </p>
  `,
    header: "",
  },
  imp: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. </p>
  `,
    header: "",
  },
  forms: {
    content: `
  <p>Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.</p>
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. </p>`,
    header: "",
  },
  ssl: {
    content: `
  <p>SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. </p>
  <p>Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. </p>
  <p>Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. </p>`,
    header: "",
  },
  captcha: {
    content: `
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen.</p>`,
    header: "",
  },
  headers: {
    content: `
  <p>
  Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind.
  </p>
  <p>
  Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden.
  </p>
  <p>
Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle.
</p>`,
    header: "",
  },
  phoneEmail: {
    content: `
  <p>
  Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. 
  </p>
  <p>
  Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. 
  </p> 
  <p>
    Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. 
  </p>
  <p>
  Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind.   </p>`,
    header: "",
  },
  software: {
    content: `
  <p>
  Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt.   </p>
  <p>
  Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren. 
    </p> 
  <p>
  Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.   </p>
`,
 header: "",
  }
},
WEB_PREMIUM: {
  securityFlags : {
    content: `Ohne die korrekte Konfiguration der Cookie Security Flags ist es möglich, Sitzungen von Webanwendungen zu manipulieren und/oder Cookies zu stehlen oder zu bearbeiten.
    `,
    header: "",

  },
  encryption : {
    content: `In der Regel bietet der Webserver verschiedene Verschlüsselungsverfahren (SSH/TLS/SSL) an, die bei Datenübertragung und Authentifizierung verwendet werden können. Manche dieser Verfahren sind jedoch als schwach eingestuft (z.B. weil die Schlüssellänge zu kurz ist). Diese Verschlüsselungsmethoden sollten daher nicht angeboten/genutzt werden. `,
header :""
  },
  software: {
    content: `
  <p>
  Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt.   </p>
  <p>
  Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren. 
    </p> 
  <p>
  Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.   </p>
`,
 header: "",
  },
  technicalDetails: {
    content: `<p>Die IP-Adresse (IP steht für Internet Protocoll) ist eine eindeutige Identifizierungsnummer, die einem Gerät im Internet zugeordnet ist. Die hier angeführte IP-Adresse ist jene des Webservers, von der die Webseite geladen wird. </p>
    <p>Die Anzahl der Links/Seiten einer Webseite kann ein Indikator für die "Größe" einer Webseite sein. Zur Orientierung: Kleinere Webseiten haben in der Regel eine zweistellige Anzahl von Seiten. </p>
    `,
    header: ""
  },
  externalContent: {
    content: `<p>Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten: </p>
    <p>- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.  </p>
    <p>- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen. </p>
    <p>- Unerlaubte Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). Dies kann potenziell eine Verletzung der DSGVO und anderer Datenschutzregelungen bedeuten. </p>
    <p>- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.</p>
    <p>Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).</p>`,
    header : ""

  },
  cookieBanner: {
    content: `
  <p>Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. </p>
  <p>Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. </p>
    <p>Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.</p>
      <p>Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. </p>

  `,
    header: "",
  },
  cookieCheck: {
    content: `
    <p>Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: </p>
        <p><strong><i>Funktionale (technisch notwendige) Cookies: </i></strong>z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security. Diese Cookies dürfen ohne Zustimmung des Webseitenbesuchers aktiviert werden.</p>
            <p><strong><i>Nicht technisch notwendige Cookies: </i></strong>z.B. für Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics. Diese Cookies dürfen erst nach Zustimmung des Webseitenbesuchers aktiviert werden.</p>
    <p>Alle Cookies sollen zusätzlich in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). </p>
  `,
    header: "",
  },
  dat: {
    content: `
  <p><u>Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert. Der Webseitenbesucher muss zusätzlich auch über seine Rechte aufgeklärt werden (z.B. Recht auf Löschung, Widerruf, Widerspruch oder Beschwerde). </p>
    <p>V.a. die Verarbeitung von Daten in Drittstaaten (Länder außerhalb der EU) ist mitunter problematisch. Dies betrifft z.B. die Aktivierung von nicht technisch notwendigen Cookies von US-Anbietern (wie z.B. Google Analytics/YouTube von Google oder Facebook Ads von Meta). Die Gesetzeslage ist hier sehr dynamisch und ändert sich relativ häufig; zur konkreten Abklärung wird die Beratung durch einen zugelassenen Rechtsanwalt empfohlen. </p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). </p>

  `,
    header: "",
  },
  cok: {
    content: ` <p><u>Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).</p>`,
    header: "",
  },
  agb: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. </p>
  <p>Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. </p>
  `,
    header: "",
  },
  imp: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. </p>
  `,
    header: "",
  },
  forms: {
    content: `
  <p>Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.</p>
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. </p>`,
    header: "",
  },
  ssl: {
    content: `
  <p>SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. </p>
  <p>Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. </p>
  <p>Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. </p>`,
    header: "",
  },
  captcha: {
    content: `
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen.</p>`,
    header: "",
  },
  headers: {
    content: `
  <p>
  Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind.
  </p>
  <p>
  Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden.
  </p>
  <p>
Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle.
</p>`,
    header: "",
  },
  phoneEmail: {
    content: `
  <p>
  Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. 
  </p>
  <p>
  Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. 
  </p> 
  <p>
    Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. 
  </p>
  <p>
  Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind.   </p>`,
    header: "",
  },
   
},
WEB_SWISS: {
  encryption:null,
  securityFlags:null,
  technicalDetails:null,
  cookieBanner:null,

  externalContent: {
    content: `<p>Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver gel- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.  </p>
    <p>- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.</p>
    <p>- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen.</p>
    <p>- Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). </p>
    <p>- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.</p>
    <p>Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).</p>`,
    header : ""

  },
  cookieCheck: {
    content: `
    <p>Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. </p>
        <p>Beispielsweise werden Cookies eingesetzt, um die Funktion der Webseite zu ermöglichen (z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security). Oder Cookies werden zu Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen verwendet. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics.</p>
            <p>Alle Cookies müssen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden.</p>
  `,
    header: "",
  },
  dat: {
    content: `
  <p><u>Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert.</p>
    <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden.</p>
  `,
    header: "",
  },
  cok: {
    content: ` <p><u>Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).</p>`,
    header: "",
  },
  agb: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. </p>
  <p>Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. </p>
  `,
    header: "",
  },
  imp: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. </p>
  `,
    header: "",
  },
  forms: {
    content: `
  <p>Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.</p>
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. </p>`,
    header: "",
  },
  ssl: {
    content: `
  <p>SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. </p>
  <p>Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. </p>
  <p>Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. </p>`,
    header: "",
  },
  captcha: {
    content: `
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen.</p>`,
    header: "",
  },
  headers: {
    content: `
  <p>
  Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind.
  </p>
  <p>
  Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden.
  </p>
  <p>
Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle.
</p>`,
    header: "",
  },
  phoneEmail: {
    content: `
  <p>
  Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. 
  </p>
  <p>
  Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. 
  </p> 
  <p>
    Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. 
  </p>
  <p>
  Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind.   </p>`,
    header: "",
  },
  software: {
    content: `
  <p>
  Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt.   </p>
  <p>
  Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren. 
    </p> 
  <p>
  Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.   </p>
`,
 header: "",
  }
},
WEB_SECURITY: {
  encryption : {
    content: `In der Regel bietet der Webserver verschiedene Verschlüsselungsverfahren (SSH/TLS/SSL) an, die bei Datenübertragung und Authentifizierung verwendet werden können. Manche dieser Verfahren sind jedoch als schwach eingestuft (z.B. weil die Schlüssellänge zu kurz ist). Diese Verschlüsselungsmethoden sollten daher nicht angeboten/genutzt werden. `,
header :""
  },

  securityFlags : {
    content: `Ohne die korrekte Konfiguration der Cookie Security Flags ist es möglich, Sitzungen von Webanwendungen zu manipulieren und/oder Cookies zu stehlen oder zu bearbeiten.
    `,
    header: "",

  },

  software: {
    content: `
  <p>
  Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt.   </p>
  <p>
  Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren. 
    </p> 
  <p>
  Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.   </p>
`,
 header: "",
  }
,
  technicalDetails: {
    content: `<p>Die IP-Adresse (IP steht für Internet Protocoll) ist eine eindeutige Identifizierungsnummer, die einem Gerät im Internet zugeordnet ist. Die hier angeführte IP-Adresse ist jene des Webservers, von der die Webseite geladen wird. </p>
    <p>Die Anzahl der Links/Seiten einer Webseite kann ein Indikator für die "Größe" einer Webseite sein. Zur Orientierung: Kleinere Webseiten haben in der Regel eine zweistellige Anzahl von Seiten. </p>
    `,
    header: ""
  },
  externalContent: {
    content: `<p>Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten: </p>
    <p>- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.  </p>
    <p>- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen. </p>
    <p>- Unerlaubte Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). Dies kann potenziell eine Verletzung der DSGVO und anderer Datenschutzregelungen bedeuten. </p>
    <p>- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.</p>
    <p>Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).</p>`,
    header : ""

  },
  cookieBanner: {
    content: `
  <p>Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. </p>
  <p>Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. </p>
    <p>Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.</p>
      <p>Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. </p>

  `,
    header: "",
  },
  cookieCheck: {
    content: `
    <p>Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: </p>
        <p><strong><i>Funktionale (technisch notwendige) Cookies: </i></strong>z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security. Diese Cookies dürfen ohne Zustimmung des Webseitenbesuchers aktiviert werden.</p>
            <p><strong><i>Nicht technisch notwendige Cookies: </i></strong>z.B. für Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics. Diese Cookies dürfen erst nach Zustimmung des Webseitenbesuchers aktiviert werden.</p>
    <p>Alle Cookies sollen zusätzlich in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). </p>
  `,
    header: "",
  },
  dat: {
    content: `
  <p><u>Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert. Der Webseitenbesucher muss zusätzlich auch über seine Rechte aufgeklärt werden (z.B. Recht auf Löschung, Widerruf, Widerspruch oder Beschwerde). </p>
    <p>V.a. die Verarbeitung von Daten in Drittstaaten (Länder außerhalb der EU) ist mitunter problematisch. Dies betrifft z.B. die Aktivierung von nicht technisch notwendigen Cookies von US-Anbietern (wie z.B. Google Analytics/YouTube von Google oder Facebook Ads von Meta). Die Gesetzeslage ist hier sehr dynamisch und ändert sich relativ häufig; zur konkreten Abklärung wird die Beratung durch einen zugelassenen Rechtsanwalt empfohlen. </p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). </p>

  `,
    header: "",
  },
  cok: {
    content: ` <p><u>Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).</p>`,
    header: "",
  },
  agb: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. </p>
  <p>Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. </p>
  `,
    header: "",
  },
  imp: {
    content: `<p><u>Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.</u></p>
  <p>Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. </p>
  `,
    header: "",
  },
  forms: {
    content: `
  <p>Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.</p>
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. </p>`,
    header: "",
  },
  ssl: {
    content: `
  <p>SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. </p>
  <p>Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. </p>
  <p>Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. </p>`,
    header: "",
  },
  captcha: {
    content: `
  <p>Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen.</p>`,
    header: "",
  },
  headers: {
    content: `
  <p>
  Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind.
  </p>
  <p>
  Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden.
  </p>
  <p>
Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle.
</p>`,
    header: "",
  },
  phoneEmail: {
    content: `
  <p>
  Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. 
  </p>
  <p>
  Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. 
  </p> 
  <p>
    Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. 
  </p>
  <p>
  Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind.   </p>`,
    header: "",
  },
   
},
};

export const WEBSITE_CHECK_INFO_PDF : {[key in WebcaseWorkflowType]: any }= {
  WEB_STANDARD: {
    software: { header: "Allgemeine Informationen zu Software inkl. Versionscheck",
    paragraphs:  [
      {
        content: "Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt. ",
        style: "normal"
      },
      {
        content: "Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren.",
        style: "normal"
      },
      {
        content: "Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.",
        style: "normal"
      }
  
    ]
  },
  encryption: {
  header: "Allgemeine Informationen zu Verschlüsselung",
  paragraphs:  [
    {
      content: "In der Regel bietet der Webserver verschiedene Verschlüsselungsverfahren (SSH/TLS/SSL) an, die bei Datenübertragung und Authentifizierung verwendet werden können. Manche dieser Verfahren sind jedoch als schwach eingestuft (z.B. weil die Schlüssellänge zu kurz ist). Diese Verschlüsselungsmethoden sollten daher nicht angeboten/genutzt werden. ",
      style: "normal"
    }
  ]
  },
  securityFlags: {
    header: "Allgemeine Informationen zu Security Flags Cookies",
    paragraphs:  [
      {
        content: "Ohne die korrekte Konfiguration der Cookie Security Flags ist es möglich, Sitzungen von Webanwendungen zu manipulieren und/oder Cookies zu stehlen oder zu bearbeiten.",
        style: "normal"
      }
    ]
    },
  externalContent:{
    header: "Allgemeine Informationen zu extern geladenen Inhalte",
    paragraphs: [
      {
        content:
          "Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten:",
        style: "normal",
      },
      {
        content:
          "- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.",
        style: "normal",
      },
      {
        content:
          "- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen.",
        style: "normal",
      },
      {
        content:
          "- Unerlaubte Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). Dies kann potenziell eine Verletzung der DSGVO und anderer Datenschutzregelungen bedeuten. ",
        style: "normal",
      },   {
        content:
          "- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.",
        style: "normal",
        
      },
      {
        content:
          "Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).",
        style: "normal",
        
      },
    ]
  },
  cookieBanner: {
    header: "Allgemeine Informationen zum Cookie-Banner",
    paragraphs: [
      {
        content:
          "Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. ",
        style: "normal",
      },
      {
        content:
          "Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. ",
        style: "normal",
      },
      {
        content:
          "Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.",
        style: "normal",
      },
      {
        content:
          "Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. ",
        style: "normal",
      },
    ],
  },
  cookieCheck: {
    header: "Allgemeine Informationen zu Cookies",
    paragraphs: [
      {
        content:
          "Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: ",
        style: "normal",
      },
      {
        content:
          "Funktionale (technisch notwendige) Cookies: z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security. Diese Cookies dürfen ohne Zustimmung des Webseitenbesuchers aktiviert werden.",

        style: "normal",
      },
      {
        content:
          "Nicht technisch notwendige Cookies: z.B. für Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics. Diese Cookies dürfen erst nach Zustimmung des Webseitenbesuchers aktiviert werden.",
        style: "normal",
      },
      {
        content:
          "Alle Cookies sollen zusätzlich in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). ",
        style: "normal",
      },
    ],
  },
  dat: {
    header: "Allgemeine Informationen zur Datenschutzerklärung",
    paragraphs: [
      {
        content:
          "Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
        style: "italic",
      },
      {
        content:
          "In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert. Der Webseitenbesucher muss zusätzlich auch über seine Rechte aufgeklärt werden (z.B. Recht auf Löschung, Widerruf, Widerspruch oder Beschwerde). ",
        style: "normal",
      },
      {
        content:
          "V.a. die Verarbeitung von Daten in Drittstaaten (Länder außerhalb der EU) ist mitunter problematisch. Dies betrifft z.B. die Aktivierung von nicht technisch notwendigen Cookies von US-Anbietern (wie z.B. Google Analytics/YouTube von Google oder Facebook Ads von Meta). Die Gesetzeslage ist hier sehr dynamisch und ändert sich relativ häufig; zur konkreten Abklärung wird die Beratung durch einen zugelassenen Rechtsanwalt empfohlen. ",
        style: "normal",
      },
      {
        content:
          "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). ",
        style: "normal",
      },
    ],
  },
  cok: {
    header: "Allgemeine Informationen zu Cookie-Richtlinien",
    paragraphs: [
      {
        content:
          "Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
        style: "italic",
      },
      {
        content:
          "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).",
        style: "normal",
      },
    ],
  },
  agb: {
    header: "Allgemeine Informationen zu Webshop AGB",
    paragraphs: [
      {
        content:
          "Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
        style: "italic",
      },
      {
        content:
          "In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. ",
        style: "normal",
      },
      {
        content:
          "Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. ",
        style: "normal",
      },
    ],
  },
  imp: {
    header: "Allgemeine Informationen zum Impressum",
    paragraphs: [
      {
        content:
          "Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
        style: "italic",
      },
      {
        content:
          "Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. ",
        style: "normal",
      },
      {
        content:
          "Beim Impressumcheck wird nur überprüft, ob ein Firmenname, eine Adresse, eine Telefonnummer und eine E-Mail Adresse vorhanden sind. Abhängig von Unternehmensform, Branche und Land können weitere Inhalte gesetzlich vorgeschrieben sein. Für weitere Infos dazu kontaktieren Sie bitte einen Rechtsanwalt.",
        color: "#e18207",
        style: "normal",
      },
    ],
  },
  forms: {
    header: "Allgemeine Informationen zu Webformularen",
    paragraphs: [
      {
        content:
          "Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.",
        style: "normal",
      },
      {
        content:
          "Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. ",
        style: "normal",
      },
    ],
  },
  phoneEmail: {
    header: "Allgemeine Informationen zu Telefon/E-Mail sichtbar",
    paragraphs: [
      {
        content:
          "Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. ",
        style: "normal",
      },
      {
        content:
          "Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. ",
        style: "normal",
      },
      {
        content:
          "Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. ",
        style: "normal",
      },
      {
        content:
          "Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind. ",
        style: "normal",
      },
 
    ],
  },

  security: {
    header: "Allgemeine Informationen zum SSL-Zertifikat",
    paragraphs: [
      {
        content:
          "SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. ",
        style: "italic",
      },
      {
        content:
          "Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. ",
        style: "normal",
      },
      {
        content:
          "Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. ",
        style: "normal",
      },
    ],
  },
  technicalDetails: {
    header: "Allgemeine Informationen zu Technische Details",
    paragraphs: [
    
      {
        content:
          "Die IP-Adresse (IP steht für Internet Protocoll) ist eine eindeutige Identifizierungsnummer, die einem Gerät im Internet zugeordnet ist. Die hier angeführte IP-Adresse ist jene des Webservers, von der die Webseite geladen wird.",
        style: "normal",
      },
      {
        content:
          `Die Anzahl der Links/Seiten einer Webseite kann ein Indikator für die "Größe" einer Webseite sein. Zur Orientierung: Kleinere Webseiten haben in der Regel eine zweistellige Anzahl von Seiten. `,
        style: "normal",
      },
    ],
  },
  securityHeader: {
    header: "Allgemeine Informationen zu Security Header",
    paragraphs: [
    
      {
        content:
          "Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind. ",
        style: "normal",
      },
      {
        content:"Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden. ",
        style: "normal",
      },
      {
        content:"Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle. ",
        style: "normal",
      },  
    ],
  }},
  WEB_PREMIUM: {
    externalContent:{
      header: "Allgemeine Informationen zu extern geladenen Inhalte",
      paragraphs: [
        {
          content:
            "Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten:",
          style: "normal",
        },
        {
          content:
            "- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.",
          style: "normal",
        },
        {
          content:
            "- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen.",
          style: "normal",
        },
        {
          content:
            "- Unerlaubte Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). Dies kann potenziell eine Verletzung der DSGVO und anderer Datenschutzregelungen bedeuten. ",
          style: "normal",
        },   {
          content:
            "- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.",
          style: "normal",
          
        },
        {
          content:
            "Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).",
          style: "normal",
          
        },
      ]
    },
    cookieBanner: {
      header: "Allgemeine Informationen zum Cookie-Banner",
      paragraphs: [
        {
          content:
            "Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. ",
          style: "normal",
        },
        {
          content:
            "Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. ",
          style: "normal",
        },
        {
          content:
            "Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.",
          style: "normal",
        },
        {
          content:
            "Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. ",
          style: "normal",
        },
      ],
    },
    cookieCheck: {
      header: "Allgemeine Informationen zu Cookies",
      paragraphs: [
        {
          content:
            "Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: ",
          style: "normal",
        },
        {
          content:
            "Funktionale (technisch notwendige) Cookies: z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security. Diese Cookies dürfen ohne Zustimmung des Webseitenbesuchers aktiviert werden.",
  
          style: "normal",
        },
        {
          content:
            "Nicht technisch notwendige Cookies: z.B. für Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics. Diese Cookies dürfen erst nach Zustimmung des Webseitenbesuchers aktiviert werden.",
          style: "normal",
        },
        {
          content:
            "Alle Cookies sollen zusätzlich in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). ",
          style: "normal",
        },
      ],
    },
    dat: {
      header: "Allgemeine Informationen zur Datenschutzerklärung",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert. Der Webseitenbesucher muss zusätzlich auch über seine Rechte aufgeklärt werden (z.B. Recht auf Löschung, Widerruf, Widerspruch oder Beschwerde). ",
          style: "normal",
        },
        {
          content:
            "V.a. die Verarbeitung von Daten in Drittstaaten (Länder außerhalb der EU) ist mitunter problematisch. Dies betrifft z.B. die Aktivierung von nicht technisch notwendigen Cookies von US-Anbietern (wie z.B. Google Analytics/YouTube von Google oder Facebook Ads von Meta). Die Gesetzeslage ist hier sehr dynamisch und ändert sich relativ häufig; zur konkreten Abklärung wird die Beratung durch einen zugelassenen Rechtsanwalt empfohlen. ",
          style: "normal",
        },
        {
          content:
            "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). ",
          style: "normal",
        },
      ],
    },
    cok: {
      header: "Allgemeine Informationen zu Cookie-Richtlinien",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).",
          style: "normal",
        },
      ],
    },
    agb: {
      header: "Allgemeine Informationen zu Webshop AGB",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. ",
          style: "normal",
        },
        {
          content:
            "Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. ",
          style: "normal",
        },
      ],
    },
    imp: {
      header: "Allgemeine Informationen zum Impressum",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. ",
          style: "normal",
        },
        {
          content:
            "Beim Impressumcheck wird nur überprüft, ob ein Firmenname, eine Adresse, eine Telefonnummer und eine E-Mail Adresse vorhanden sind. Abhängig von Unternehmensform, Branche und Land können weitere Inhalte gesetzlich vorgeschrieben sein. Für weitere Infos dazu kontaktieren Sie bitte einen Rechtsanwalt.",
          color: "#e18207",
          style: "normal",
        },
      ],
    },
    forms: {
      header: "Allgemeine Informationen zu Webformularen",
      paragraphs: [
        {
          content:
            "Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.",
          style: "normal",
        },
        {
          content:
            "Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. ",
          style: "normal",
        },
      ],
    },
  
    security: {
      header: "Allgemeine Informationen zum SSL-Zertifikat",
      paragraphs: [
        {
          content:
            "SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. ",
          style: "italic",
        },
        {
          content:
            "Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. ",
          style: "normal",
        },
        {
          content:
            "Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. ",
          style: "normal",
        },
      ],
    }
    ,
    technicalDetails: {
      header: "Allgemeine Informationen zu Technische Details",
      paragraphs: [
      
        {
          content:
            "Die IP-Adresse (IP steht für Internet Protocoll) ist eine eindeutige Identifizierungsnummer, die einem Gerät im Internet zugeordnet ist. Die hier angeführte IP-Adresse ist jene des Webservers, von der die Webseite geladen wird.",
          style: "normal",
        },
        {
          content:
            `Die Anzahl der Links/Seiten einer Webseite kann ein Indikator für die "Größe" einer Webseite sein. Zur Orientierung: Kleinere Webseiten haben in der Regel eine zweistellige Anzahl von Seiten. `,
          style: "normal",
        },
      ],
    },
    securityHeader: {
      header: "Allgemeine Informationen zu Security Header",
      paragraphs: [
      
        {
          content:
            "Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind. ",
          style: "normal",
        },
        {
          content:"Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden. ",
          style: "normal",
        },
        {
          content:"Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle. ",
          style: "normal",
        },  
      ],
    },
    phoneEmail: {
      header: "Allgemeine Informationen zu Telefon/E-Mail sichtbar",
      paragraphs: [
        {
          content:
            "Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. ",
          style: "normal",
        },
        {
          content:
            "Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. ",
          style: "normal",
        },
        {
          content:
            "Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. ",
          style: "normal",
        },
        {
          content:
            "Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind. ",
          style: "normal",
        },
   
      ],
    },  software: { header: "Allgemeine Informationen zu Software inkl. Versionscheck",
    paragraphs:  [
      {
        content: "Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt. ",
        style: "normal"
      },
      {
        content: "Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren.",
        style: "normal"
      },
      {
        content: "Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.",
        style: "normal"
      }
  
    ]
  },
  encryption: {
  header: "Allgemeine Informationen zu Verschlüsselung",
  paragraphs:  [
    {
      content: "In der Regel bietet der Webserver verschiedene Verschlüsselungsverfahren (SSH/TLS/SSL) an, die bei Datenübertragung und Authentifizierung verwendet werden können. Manche dieser Verfahren sind jedoch als schwach eingestuft (z.B. weil die Schlüssellänge zu kurz ist). Diese Verschlüsselungsmethoden sollten daher nicht angeboten/genutzt werden. ",
      style: "normal"
    }
  ]
  },
  securityFlags: {
    header: "Allgemeine Informationen zu Security Flags Cookies",
    paragraphs:  [
      {
        content: "Ohne die korrekte Konfiguration der Cookie Security Flags ist es möglich, Sitzungen von Webanwendungen zu manipulieren und/oder Cookies zu stehlen oder zu bearbeiten.",
        style: "normal"
      }
    ]
    }},
  WEB_SECURITY: {
    externalContent:{
      header: "Allgemeine Informationen zu extern geladenen Inhalte",
      paragraphs: [
        {
          content:
            "Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten:",
          style: "normal",
        },
        {
          content:
            "- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.",
          style: "normal",
        },
        {
          content:
            "- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen.",
          style: "normal",
        },
        {
          content:
            "- Unerlaubte Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet). Dies kann potenziell eine Verletzung der DSGVO und anderer Datenschutzregelungen bedeuten. ",
          style: "normal",
        },   {
          content:
            "- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.",
          style: "normal",
          
        },
        {
          content:
            "Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).",
          style: "normal",
          
        },
      ]
    },
    cookieBanner: {
      header: "Allgemeine Informationen zum Cookie-Banner",
      paragraphs: [
        {
          content:
            "Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. ",
          style: "normal",
        },
        {
          content:
            "Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. ",
          style: "normal",
        },
        {
          content:
            "Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.",
          style: "normal",
        },
        {
          content:
            "Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. ",
          style: "normal",
        },
      ],
    },
    cookieCheck: {
      header: "Allgemeine Informationen zu Cookies",
      paragraphs: [
        {
          content:
            "Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: ",
          style: "normal",
        },
        {
          content:
            "Funktionale (technisch notwendige) Cookies: z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security. Diese Cookies dürfen ohne Zustimmung des Webseitenbesuchers aktiviert werden.",
  
          style: "normal",
        },
        {
          content:
            "Nicht technisch notwendige Cookies: z.B. für Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics. Diese Cookies dürfen erst nach Zustimmung des Webseitenbesuchers aktiviert werden.",
          style: "normal",
        },
        {
          content:
            "Alle Cookies sollen zusätzlich in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). ",
          style: "normal",
        },
      ],
    },
    dat: {
      header: "Allgemeine Informationen zur Datenschutzerklärung",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert. Der Webseitenbesucher muss zusätzlich auch über seine Rechte aufgeklärt werden (z.B. Recht auf Löschung, Widerruf, Widerspruch oder Beschwerde). ",
          style: "normal",
        },
        {
          content:
            "V.a. die Verarbeitung von Daten in Drittstaaten (Länder außerhalb der EU) ist mitunter problematisch. Dies betrifft z.B. die Aktivierung von nicht technisch notwendigen Cookies von US-Anbietern (wie z.B. Google Analytics/YouTube von Google oder Facebook Ads von Meta). Die Gesetzeslage ist hier sehr dynamisch und ändert sich relativ häufig; zur konkreten Abklärung wird die Beratung durch einen zugelassenen Rechtsanwalt empfohlen. ",
          style: "normal",
        },
        {
          content:
            "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft). ",
          style: "normal",
        },
      ],
    },
    cok: {
      header: "Allgemeine Informationen zu Cookie-Richtlinien",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).",
          style: "normal",
        },
      ],
    },
    agb: {
      header: "Allgemeine Informationen zu Webshop AGB",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. ",
          style: "normal",
        },
        {
          content:
            "Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. ",
          style: "normal",
        },
      ],
    },
    imp: {
      header: "Allgemeine Informationen zum Impressum",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. ",
          style: "normal",
        },
        {
          content:
            "Beim Impressumcheck wird nur überprüft, ob ein Firmenname, eine Adresse, eine Telefonnummer und eine E-Mail Adresse vorhanden sind. Abhängig von Unternehmensform, Branche und Land können weitere Inhalte gesetzlich vorgeschrieben sein. Für weitere Infos dazu kontaktieren Sie bitte einen Rechtsanwalt.",
          color: "#e18207",
          style: "normal",
        },
      ],
    },
    forms: {
      header: "Allgemeine Informationen zu Webformularen",
      paragraphs: [
        {
          content:
            "Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.",
          style: "normal",
        },
        {
          content:
            "Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. ",
          style: "normal",
        },
      ],
    },
  
    security: {
      header: "Allgemeine Informationen zum SSL-Zertifikat",
      paragraphs: [
        {
          content:
            "SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. ",
          style: "italic",
        },
        {
          content:
            "Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. ",
          style: "normal",
        },
        {
          content:
            "Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. ",
          style: "normal",
        },
      ],
    }
    ,
    technicalDetails: {
      header: "Allgemeine Informationen zu Technische Details",
      paragraphs: [
      
        {
          content:
            "Die IP-Adresse (IP steht für Internet Protocoll) ist eine eindeutige Identifizierungsnummer, die einem Gerät im Internet zugeordnet ist. Die hier angeführte IP-Adresse ist jene des Webservers, von der die Webseite geladen wird.",
          style: "normal",
        },
        {
          content:
            `Die Anzahl der Links/Seiten einer Webseite kann ein Indikator für die "Größe" einer Webseite sein. Zur Orientierung: Kleinere Webseiten haben in der Regel eine zweistellige Anzahl von Seiten. `,
          style: "normal",
        },
      ],
    },
    securityHeader: {
      header: "Allgemeine Informationen zu Security Header",
      paragraphs: [
      
        {
          content:
            "Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind. ",
          style: "normal",
        },
        {
          content:"Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden. ",
          style: "normal",
        },
        {
          content:"Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle. ",
          style: "normal",
        },  
      ],
    },
    phoneEmail: {
      header: "Allgemeine Informationen zu Telefon/E-Mail sichtbar",
      paragraphs: [
        {
          content:
            "Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. ",
          style: "normal",
        },
        {
          content:
            "Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. ",
          style: "normal",
        },
        {
          content:
            "Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. ",
          style: "normal",
        },
        {
          content:
            "Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind. ",
          style: "normal",
        },
   
      ],
    },  software: { header: "Allgemeine Informationen zu Software inkl. Versionscheck",
  paragraphs:  [
    {
      content: "Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt. ",
      style: "normal"
    },
    {
      content: "Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren.",
      style: "normal"
    },
    {
      content: "Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.",
      style: "normal"
    }

  ]
},
encryption: {
header: "Allgemeine Informationen zu Verschlüsselung",
paragraphs:  [
  {
    content: "In der Regel bietet der Webserver verschiedene Verschlüsselungsverfahren (SSH/TLS/SSL) an, die bei Datenübertragung und Authentifizierung verwendet werden können. Manche dieser Verfahren sind jedoch als schwach eingestuft (z.B. weil die Schlüssellänge zu kurz ist). Diese Verschlüsselungsmethoden sollten daher nicht angeboten/genutzt werden. ",
    style: "normal"
  }
]
},
securityFlags: {
  header: "Allgemeine Informationen zu Security Flags Cookies",
  paragraphs:  [
    {
      content: "Ohne die korrekte Konfiguration der Cookie Security Flags ist es möglich, Sitzungen von Webanwendungen zu manipulieren und/oder Cookies zu stehlen oder zu bearbeiten.",
      style: "normal"
    }
  ]
  },
},
  WEB_SWISS: {
    externalContent:{
      header: "Allgemeine Informationen zu extern geladenen Inhalte",
      paragraphs: [
        {
          content:
            "Extern geladene Inhalte werden von anderen Quellen als dem eigenen Webserver geladen. Dies können z.B. Bilder, Videos, Schriftarten, Designs oder Applikationen sein. Folgende Probleme können auftreten:",
          style: "normal",
        },
        {
          content:
            "- Unseriöse/Nicht vertrauenswürdige Quellen: Beim Laden von ungewollten und/oder unsicheren Inhalten kann für die Webseite bzw. den Webseitenbesucher ein Sicherheitsproblem entstehen. Bitte prüfen Sie deshalb, ob alle extern geladenen Inhalte aus seriösen Quellen stammen und das Laden dieser Inhalte auch gewollt ist.",
          style: "normal",
        },
        {
          content:
            "- Verletzung Urheberrecht: Betrifft v.a. Mediendateien wie Bilder, Videos, Icons etc.; bitte überprüfen Sie, ob Sie alle extern geladenen Dateien nutzen dürfen und nicht das Urheberrecht des eigentlichen Inhabers verletzen.",
          style: "normal",
        },
        {
          content:
            "- Übertragung von persönlichen Daten: Beim Laden gewisser externer Inhalte werden Daten des Webseitenbesuchers an Dritte weitergeleitet (z.B. beim Laden von Google Fonts wird die IP-Adresse des Users an Google weitergeleitet).",
          style: "normal",
        },   {
          content:
            "- Redundante Inhalte: Inhalte werden geladen, die für die Funktion der Webseite jedoch nicht notwendig sind. Dadurch kann die Seite potenziell langsamer laden & die Webseite wird in Suchmaschinen schlechter gereiht.",
          style: "normal",
          
        },
        {
          content:
            "Die Thematik ist sehr technisch; wenn Sie selbst nicht über das notwendige Wissen verfügen, um die oben genannten Punkte zu prüfen, nehmen Sie bitte Kontakt mit den entsprechenden Dienstleistern auf (z.B. Webagentur, IT/EDV-Unternehmen etc.).",
          style: "normal",
          
        },
      ]
    },
    cookieBanner: {
      header: "Allgemeine Informationen zum Cookie-Banner",
      paragraphs: [
        {
          content:
            "Um die Zustimmung (= Consent) des Users zum Setzen von Cookies einzuholen bzw. auch zu dokumentieren, empfiehlt sich der Einsatz eines Cookie-Banners. ",
          style: "normal",
        },
        {
          content:
            "Gemäß einem Urteil des EuGH im Oktober 2019 (Rechtssache C 673/17) dürfen Cookies auf einer Webseite erst nach Zustimmung des Users gesetzt werden. Das bedeutet, die Cookies dürfen erst aktiviert werden, nachdem der User z.B. über ein Cookie-Banner per Klick seine Zustimmung dazu gegeben hat. Werden Cookies ohne diese Zustimmung (Consent) gesetzt, ist dies rechtswidrig. ",
          style: "normal",
        },
        {
          content:
            "Unterschieden werden muss zwischen technisch notwendigen und nicht technisch notwendigen Cookies. Die Aktivierung von technisch notwendigen Cookies ist auch ohne Cookie-Banner gesetzeskonform. Das Cookie-Banner ist dann korrekt implementiert, wenn alle nicht-technischen Cookies erst nach Einverständnis des Users aktiviert werden.",
          style: "normal",
        },
        {
          content:
            "Das Cookie-Banner sollte auch einen „Alle ablehnen“-Button haben, mit dessen Hilfe der User mit nur einem Klick der Aktivierung von Cookies widersprechen kann. ",
          style: "normal",
        },
      ],
    },
    cookieCheck: {
      header: "Allgemeine Informationen zu Cookies",
      paragraphs: [
        {
          content:
            "Cookies sind Daten, die eine Webseite auf dem Computer eines Users zwischenspeichert, wenn dieser die Seite besucht. Dabei wird unterschieden zwischen: ",
          style: "normal",
        },
        {
          content:
            "Beispielsweise werden Cookies eingesetzt, um die Funktion der Webseite zu ermöglichen (z.B. Cookies betreffend Warenkorbfunktion, Zahlungsabwicklung oder IT-Security). Oder Cookies werden zu Marketing- oder Analysezwecke bzw. für die Integration von Social Media Funktionen verwendet. Beispiele sind Google Analytics, Facebook Ads, Hotjar, YouTube oder Adobe Analytics.",
  
          style: "normal",
        },
        {
          content:
            "Alle Cookies müssen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden.",
          style: "normal",
        },
      ],
    },
    dat: {
      header: "Allgemeine Informationen zur Datenschutzerklärung",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der Datenschutzerklärung nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "normal",
        },
        {
          content:
            "In der Datenschutzerklärung (DSE) sollen User darüber informiert werden, welche Daten wo und von wem verarbeitet (gesammelt/gespeichert/weitergegeben) werden und was mit diesen Daten passiert.",
          style: "normal",
        },
        {
          content:
            "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden.",
          style: "normal",
        },
      ],
    },
    cok: {
      header: "Allgemeine Informationen zu Cookie-Richtlinien",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der Cookie-Richtlinien nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "Alle auf der Webseite implementierten Cookies sollen in der Datenschutzerklärung oder einer eigenen Cookie-Liste angeführt werden. Idealerweise inkludiert die Cookie-Information Name, Funktion, Speicherdauer und Domain des Cookies, sowie Informationen zum dahinterstehenden Anbieter (z.B. Google, Facebook, Microsoft).",
          style: "normal",
        },
      ],
    },
    agb: {
      header: "Allgemeine Informationen zu Webshop AGB",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung der AGB nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "In den AGB werden die Spielregeln für einen Onlinekauf festgelegt. Wobei viele der Inhalte ohnehin bereits gesetzlich geregelt sind und v.a. bei Onlinekäufen durch Verbraucher keine schlechteren Regelungen als im Gesetz festgelegt anwendbar sein dürfen. Zwecks Transparenz empfiehlt es sich jedoch, alle wichtigen Punkten in den AGB verständlich anzuführen. ",
          style: "normal",
        },
        {
          content:
            "Dazu gehören z.B. Regelungen bzgl. Widerruf, Ausschluss des Widerrufsrechts, Transportkosten, Rücksendungen, Eigentumsvorbehalt und Zahlungsabwicklung. Der User soll bei Kaufabschluss die Möglichkeit haben, die AGB einzusehen und diese per Klick zu akzeptieren. ",
          style: "normal",
        },
      ],
    },
    imp: {
      header: "Allgemeine Informationen zum Impressum",
      paragraphs: [
        {
          content:
            "Für die detaillierte Prüfung oder Überarbeitung des Impressums nehmen Sie bitte Kontakt mit einem zugelassenen Rechtsanwalt auf.",
          style: "italic",
        },
        {
          content:
            "Im Impressum muss angeführt werden, wer die Webseite betreibt (Firmen- oder Personenname + Adresse) und wie diese Person oder dieses Unternehmen kontaktiert werden kann (z.B. per Telefon oder E-Mail). Zusätzlich können abhängig von Land und Branche noch andere Impressumsangaben verpflichtend sein. Um dies im Einzelfall individuell zu prüfen, nehmen Sie bitte Kontakt zu einem zugelassenen Rechtsanwalt auf. ",
          style: "normal",
        },
        {
          content:
            "Beim Impressumcheck wird nur überprüft, ob ein Firmenname, eine Adresse, eine Telefonnummer und eine E-Mail Adresse vorhanden sind. Abhängig von Unternehmensform, Branche und Land können weitere Inhalte gesetzlich vorgeschrieben sein. Für weitere Infos dazu kontaktieren Sie bitte einen Rechtsanwalt.",
          color: "#e18207",
          style: "normal",
        },
      ],
    },
    forms: {
      header: "Allgemeine Informationen zu Webformularen",
      paragraphs: [
        {
          content:
            "Bei der Eingabe von Daten in ein Webformular werden diese Daten verarbeitet und diese Verarbeitung fällt innerhalb der EU daher unter die Regelungen der DSGVO. Wichtig ist, dass die Datenverarbeitung via Webformular in der Datenschutzerklärung erläutert wird (welche Daten werden von wem zu welchem Zweck verarbeitet, wie lange werden diese gespeichert etc.). Idealerweise akzeptiert der User vor dem Absenden des Webformulars den Inhalt der Datenschutzerklärung via Tick Box.",
          style: "normal",
        },
        {
          content:
            "Aus Sicherheitsgründen sollten Webformulare immer durch ein sogenanntes Captcha geschützt werden. Andernfalls drohen Attacken via Bots, die in kürzester Zeit unzählige Anfragen über das Formular absetzen und damit die Webseite zum Absturz bringen. ",
          style: "normal",
        },
      ],
    },
  
    security: {
      header: "Allgemeine Informationen zum SSL-Zertifikat",
      paragraphs: [
        {
          content:
            "SSL ist die Abkürzung für Secure Sockets Layer und ist ein Verschlüsselungsprotokoll, welches die sichere Kommunikation zwischen einem Browser (z.B. Firefox, Chrome) mit einem Webserver ermöglicht. Beim Aufruf einer Webseite prüft der Browser, ob die Webseite ein gültiges SSL-Zertifikat hat. Falls nicht, erscheint eine Fehlermeldung oder die Seite kann gar nicht angezeigt werden. ",
          style: "italic",
        },
        {
          content:
            "Webseiten mit gültigem SSL-Zertifikat erkennt man am „https“-Präfix in der Webadresse. Das Zertifikat muss regelmäßig erneuert werden; ein ungültiges Zertifikat ist daher entweder abgelaufen oder auf die falsche Domain ausgestellt. ",
          style: "normal",
        },
        {
          content:
            "Gemäß DSGVO müssen Datenverarbeiter die gängigen Schutzmaßnahmen ergreifen, um die Daten von Usern zu schützen. Ein gültiges SSL-Zertifikat gilt hier mittlerweile als state-of-the-art. Außerdem werden Seiten ohne gültiges SSL-Zertifikat bei Suchmaschinen schlechter gereiht. ",
          style: "normal",
        },
      ],
    },
    technicalDetails: {
      header: "Allgemeine Informationen zu Technische Details",
      paragraphs: [
      
        {
          content:
            "Die IP-Adresse (IP steht für Internet Protocoll) ist eine eindeutige Identifizierungsnummer, die einem Gerät im Internet zugeordnet ist. Die hier angeführte IP-Adresse ist jene des Webservers, von der die Webseite geladen wird.",
          style: "normal",
        },
        {
          content:
            `Die Anzahl der Links/Seiten einer Webseite kann ein Indikator für die "Größe" einer Webseite sein. Zur Orientierung: Kleinere Webseiten haben in der Regel eine zweistellige Anzahl von Seiten. `,
          style: "normal",
        },
      ],
    },
    securityHeader: {
      header: "Allgemeine Informationen zu Security Header",
      paragraphs: [
      
        {
          content:
            "Stellt ein Webbrowser zum Aufrufen einer Webseite eine Anfrage an den Webserver, antwortet dieser mit den Informationen, die der Browser zur Anzeige der Webseite benötigt. Zusätzlich kann der Webserver sogenannte Security Header an den Browser senden, in denen Sicherheitshinweise inkludiert sind. ",
          style: "normal",
        },
        {
          content:"Diese Sicherheitsanweisungen liefern dem Browser Informationen darüber, wie er sich beim Aufruf der Seite verhalten soll. Dadurch können z.B. Clickjacking, Cross-Site-Scripting oder SSL-Stripping verhindert werden. ",
          style: "normal",
        },
        {
          content:"Gewisse Security Header sollten gesetzt sein, andere vermieden oder deaktiviert werden. Siehe dazu die entsprechenden Hinweise in der Tabelle. ",
          style: "normal",
        },  
      ],
    },
    phoneEmail: {
      header: "Allgemeine Informationen zu Telefon/E-Mail sichtbar",
      paragraphs: [
        {
          content:
            "Gemäß gesetzlicher Vorgaben müssen im Impressum einer Webseite meist Kontaktdaten wie eine Telefonnummer oder E-Mail Adresse angegeben werden. Werden diese jedoch in Klarschrift (=als Text) angegeben, können diese mittels Bots automatisiert ausgelesen werden. Diesen Daten landen dann oft in Kontaktlisten oder Datenbanken, die von Betrügern für kriminelle Aktivitäten genutzt werden. ",
          style: "normal",
        },
        {
          content:
            "Beispielsweise werden an E-Mail Adressen Phishing E-Mails verschickt, um an wichtige Zugangsdaten zu gelangen (z.B. Zugang zu Onlinebanking, Finanzamt oder firmeninternen Systemen). Oder es werden gefälschte Rechnungen versandt, die täuschend echt aussehen, jedoch eine Überweisung auf ein fremdes (den Betrügern gehörendes) Konto auslösen sollen. Ein weiteres Problem sind unsichere Links, die per E-Mail verschickt werden. ",
          style: "normal",
        },
        {
          content:
            "Telefonnummern werden für sogenannte Ping-Anrufe genutzt, die oft hohe Kosten verursachen können. Per SMS können dubiose Links verschickt werden, deren Klick ein Sicherheitsrisiko darstellen. Oder Betrüger täuschen am Telefon eine andere Identität vor (z.B. Polizei, Kunde oder Lieferant), um ebenfalls wieder an Zugangsdaten oder andere geheime Informationen zu gelangen. ",
          style: "normal",
        },
        {
          content:
            "Um das automatisierte Auslesen durch Bots zu erschweren, wird daher empfohlen, die Telefonnummer und/oder E-Mail Adresse als Bilddatei in das Impressum einzufügen, weil diese schwieriger auszulesen sind. ",
          style: "normal",
        },
   
      ],
    },
  software: {
     header: "Allgemeine Informationen zu Software inkl. Versionscheck",
  paragraphs:  [
    {
      content: "Beim Aufruf einer Webseite gibt der Webserver bei schlechter Konfiguration Informationen darüber preis, welche Software bei der Webseite zum Einsatz kommt (z.B. Content Management System, Onlineshop System, PHP, JavaScript Applikationen etc.). Zusätzlich wird oftmals auch die Version der installierten Software dargelegt. ",
      style: "normal"
    },
    {
      content: "Mit Hilfe dieser Informationen können Hacker jene Webseiten identifizieren, die unsichere oder ältere Softwareversionen nutzen und diese gezielt attackieren.",
      style: "normal"
    },
    {
      content: "Idealerweise werden am Webserver nur aktuelle Softwareversionen genutzt (inkl. Sicherheits Updates, sogenannten Patches) und die Information der genutzten Software nicht nach außen preis gegeben.",
      style: "normal"
    }

  ]
},
encryption: {
header: "Allgemeine Informationen zu Verschlüsselung",
paragraphs:  [
  {
    content: "In der Regel bietet der Webserver verschiedene Verschlüsselungsverfahren (SSH/TLS/SSL) an, die bei Datenübertragung und Authentifizierung verwendet werden können. Manche dieser Verfahren sind jedoch als schwach eingestuft (z.B. weil die Schlüssellänge zu kurz ist). Diese Verschlüsselungsmethoden sollten daher nicht angeboten/genutzt werden. ",
    style: "normal"
  }
]
},
securityFlags: {
  header: "Allgemeine Informationen zu Security Flags Cookies",
  paragraphs:  [
    {
      content: "Ohne die korrekte Konfiguration der Cookie Security Flags ist es möglich, Sitzungen von Webanwendungen zu manipulieren und/oder Cookies zu stehlen oder zu bearbeiten.",
      style: "normal"
    }
  ]
  }
  }

};

export type WebcaseWorkflowType = 'WEB_STANDARD' | 'WEB_PREMIUM' | 'WEB_SWISS' | 'WEB_SWISS_2' | 'WEB_SECURITY';

export type ToDoItems = "COOKIES_UNKNOWN_FOUND" | "COOKIE_BANNER_COOKIES_WITHOUT_CONSENT" | "COOKIE_BANNER_MISSING" | "COOKIE_BANNER_COOKIES_UNKNOWN_FOUND_FOUND" |

"COOKIES_WITHOUT_CONSENT" | "SECURITY_HEADER_MISSING_HEADERS" | "SECURITY_HEADER_FORBIDDEN_HEADER" | "COOKIES_UNLISTED_COOKIES" | "DAT_CONTENT_PROBLEM" | "DAT_COOKIES_UNLISTED_COOKIES" | "DAT_FORMS_NOT_MENTIONED" 
| "DAT_COOKIES_FOUND_NO_DAT" | "DAT_MISSING" | "COK_COOKIES_UNLISTED_COOKIES" | "CAPTCHA_FORM_WITHOUT_CAPTCHA" | 
 "AGB_CONTENT_PROBLEM" | "SOFTWARE_FOUND" | "SOFTWARE_OUTDATED" | "ENCRYPTION_UNSAFE" | "SECURITY_FLAGS_USNAFE" |  "IMP_MISSING" | "PHONE_EMAIL_VISIBLE" | "IMP_MISSING_ITEMS" | "FORMS_MISSING_CAPTCHA" | "FORMS_MENTION" | "EXTERNAL_CONTENT_FOUND" | 
 
 "SSL_INVALID" ;
 interface ToDoItem {
  order: number;
  category: string;
  reportItem: string;
  name: string;
  solution: string;
 }
const SWISS_TO_DO_ITEMS = { ENCRYPTION_UNSAFE:null,SECURITY_FLAGS_USNAFE:null,SOFTWARE_FOUND:null,SOFTWARE_OUTDATED:null, PHONE_EMAIL_VISIBLE:null, SECURITY_HEADER_FORBIDDEN_HEADER:null,
  SECURITY_HEADER_MISSING_HEADERS: null,
  //cookie-banner
  COOKIE_BANNER_COOKIES_WITHOUT_CONSENT: null,
  COOKIE_BANNER_MISSING: null,
  COOKIE_BANNER_COOKIES_UNKNOWN_FOUND_FOUND: null,

  //cookies
  COOKIES_UNKNOWN_FOUND: {
    order: 0,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Unbekannte Cookies erkannt",
    solution:
      "Bitte überprüfen Sie die Quelle und Funktion dieser Cookies und nehmen Sie diese auch in Ihre Datenschutzerklärung / Cookie-Liste auf.",
  },
  COOKIES_WITHOUT_CONSENT: null,
  COOKIES_UNLISTED_COOKIES:null,

  //DAT
  DAT_CONTENT_PROBLEM: {
    order: 0,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Fehlende/potenziell problematische Inhalte erkannt",
    solution:
      "In der Datenschutzerklärung fehlen wichtige Inhalte bzw. wurden potenziell problematische Textpassagen erkannt (siehe Thementabelle). Bitte überprüfen Sie die Datenschutzerklärung und ziehen falls notwendig die entsprechenden Rechtsexperten zu Rate.",
  },
  DAT_COOKIES_UNLISTED_COOKIES: {
    order: 1,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },
  DAT_FORMS_NOT_MENTIONED: {
    order: 2,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenverarbeitung via Webformular wird nicht erläutert",
    solution:
      "Auf der Webseite wurde mind. ein Webformular gefunden. Die Datenverarbeitung via Webformular (z.B. Kontaktseite, Newsletteranmeldung, Bewerbung für offene Stellen) muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  DAT_COOKIES_FOUND_NO_DAT: {
    order: 3,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenverarbeitung via Cookies wird nicht erläutert",
    solution:
      "Die Datenverarbeitung via Cookies muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  DAT_MISSING: {
    order: 4,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenschutzerklärung fehlt",
    solution:
      "Bitte fügen Sie eine Datenschutzerklärung ein. Sie benötigen eine Datenschutzerklärung auf Ihrer Webseite, wenn Sie z.B. Cookies einsetzen oder Daten via Webformular (z.B. Kontaktformular) verarbeiten.",
  },
  //COK
  COK_COOKIES_UNLISTED_COOKIES: {
    order: 0,
    category: "Cookie-Richtlinie",
    reportItem: "cok",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },

  //agb
  AGB_CONTENT_PROBLEM: null,
  CAPTCHA_FORM_WITHOUT_CAPTCHA: {
    order: 0,
    category: "Captcha",
    reportItem: "captcha",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },
  //imp
  IMP_MISSING: {
    order: 2,
    category: "Impressum",
    reportItem: "imp",
    name: "Impressum fehlt",
    solution:
      "Bitte Impressum einfügen, damit User den Inhaber der Webseite identifizieren können.",
  },
  IMP_MISSING_ITEMS: {
    order: 3,
    category: "Impressum",
    reportItem: "imp",
    name: "Wichtige Inhalte fehlen im Impressum",
    solution:
      "Bitte ergänzen Sie im Impressum die fehlenden Inhalte (siehe Thementabelle).",
  },
  //forms
  FORMS_MISSING_CAPTCHA: {
    order: 0,
    category: "Webformulare",
    reportItem: "forms",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },
  FORMS_MENTION: {
    order: 1,
    category: "Webformulare",
    reportItem: "forms",
    name: "Datenverarbeitung via Webformular wird nicht erläutert",
    solution:
      "Auf der Webseite wurde mind. ein Webformular gefunden. Die Datenverarbeitung via Webformular (z.B. Kontaktseite, Newsletteranmeldung, Bewerbung für offene Stellen) muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  //ssl
  SSL_INVALID: {
    order: 0,
    category: "SSL-Zertifikat",
    reportItem: "ssl",
    name: "Es wurde ein ungültiges SSL-Zertifikat gefunden.",
    solution: "Bitte erneuern Sie das SSL-Zertifikat.",
  }
  ,
  EXTERNAL_CONTENT_FOUND : {
    order: 0,
    category: "Extern geladete Inhalte",
    reportItem: "external-content",
    name: "Beim Laden der Webseite werden externe Inhalte wie Bilder, Applikationen oder Schriftarten geladen.",
    solution: "Bitte überprüfen Sie, ob die extern geladenen Inhalte aus seriösen Quellen stammen, kein Sicherheitsrisiko dadurch besteht und keine Urheberrechts- oder Datenschutzverletzungen begangen werden.",
  }
  
,};
export const WEBSITE_CHECK_TODO_ITEMS : {[key in WebcaseWorkflowType]: {[key in ToDoItems]: WebsiteProblem | null} } = {
  WEB_STANDARD:{ENCRYPTION_UNSAFE:null,SECURITY_FLAGS_USNAFE:null,SOFTWARE_FOUND:null,SOFTWARE_OUTDATED:null,
    PHONE_EMAIL_VISIBLE:null,
    SECURITY_HEADER_FORBIDDEN_HEADER:null,
    SECURITY_HEADER_MISSING_HEADERS: null,
  //cookie-banner
  COOKIES_UNKNOWN_FOUND: {
    order: 0,
    category: "Cookie-Banner",
    reportItem: "cookie-banner",
    name: "Unbekannte Cookies erkannt",
    solution:
      "Bitte überprüfen Sie die Quelle und Funktion dieser Cookies und nehmen Sie diese auch in Ihre Datenschutzerklärung / Cookie-Liste auf. Sollte es sich dabei nicht um technisch notwendige Cookies handeln, müssen Sie für deren Aktivierung das Einverständnis der Webseitenbesucher einholen (durch ein Cookie-Banner).",
  },
  COOKIE_BANNER_COOKIES_WITHOUT_CONSENT: {
    order: 1,
    reportItem: "cookie-banner",
    category: "Cookie-Banner",
    name: "Cookies werden ohne Einverständnis aktiviert",
    solution:
      "Auf der Webseite werden Cookies ohne Einverständnis aktiviert (siehe Liste der Cookies). Bitte stellen Sie sicher, dass Sie vor Aktivierung der Cookies per Cookie-Banner das Einverständnis der User einholen. Vor diesem Einverständnis müssen die Cookies geblockt werden.",
  },
  COOKIE_BANNER_MISSING: {
    order: 2,
    category: "Cookie-Banner",
    reportItem: "cookie-banner",
    name: "Cookie-Banner fehlt",
    solution:
      "Auf der Webseite werden Cookies aktiviert, für deren Einsatz Sie das Einverständnis der User benötigen. Bitte fügen Sie ein Cookie-Banner ein, um dieses Einverständnis einzuholen. ",
  },
  //cookies

  COOKIE_BANNER_COOKIES_UNKNOWN_FOUND_FOUND: {
    order: 0,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Unbekannte Cookies erkannt",
    solution:
      "Bitte überprüfen Sie die Quelle und Funktion dieser Cookies und nehmen Sie diese auch in Ihre Datenschutzerklärung / Cookie-Liste auf. Sollte es sich dabei nicht um technisch notwendige Cookies handeln, müssen Sie für deren Aktivierung das Einverständnis der Webseitenbesucher einholen (durch ein Cookie-Banner).",
  },
  COOKIES_WITHOUT_CONSENT: {
    order: 1,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Cookies werden ohne Einverständnis aktiviert",
    solution:
      "Auf der Webseite werden Cookies ohne Einverständnis aktiviert (siehe Liste der Cookies). Bitte stellen Sie sicher, dass Sie vor Aktivierung der Cookies per Cookie-Banner das Einverständnis der User einholen. Vor diesem Einverständnis müssen die Cookies geblockt werden.",
  },
  COOKIES_UNLISTED_COOKIES: {
    order: 2,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },

  //DAT
  DAT_CONTENT_PROBLEM: {
    order: 0,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Fehlende/potenziell problematische Inhalte erkannt",
    solution:
      "In der Datenschutzerklärung fehlen wichtige Inhalte bzw. wurden potenziell problematische Textpassagen erkannt (siehe Thementabelle). Bitte überprüfen Sie die Datenschutzerklärung und ziehen falls notwendig die entsprechenden Rechtsexperten zu Rate.",
  },
  DAT_COOKIES_UNLISTED_COOKIES: {
    order: 1,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },
  DAT_FORMS_NOT_MENTIONED: {
    order: 2,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenverarbeitung via Webformular wird nicht erläutert",
    solution:
      "Auf der Webseite wurde mind. ein Webformular gefunden. Die Datenverarbeitung via Webformular (z.B. Kontaktseite, Newsletteranmeldung, Bewerbung für offene Stellen) muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  DAT_COOKIES_FOUND_NO_DAT: {
    order: 3,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenverarbeitung via Cookies wird nicht erläutert",
    solution:
      "Die Datenverarbeitung via Cookies muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  DAT_MISSING: {
    order: 4,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenschutzerklärung fehlt",
    solution:
      "Bitte fügen Sie eine Datenschutzerklärung ein. Sie benötigen eine Datenschutzerklärung auf Ihrer Webseite, wenn Sie z.B. Cookies einsetzen oder Daten via Webformular (z.B. Kontaktformular) verarbeiten.",
  },
  //COK
  COK_COOKIES_UNLISTED_COOKIES: {
    order: 0,
    category: "Cookie-Richtlinie",
    reportItem: "cok",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },
  CAPTCHA_FORM_WITHOUT_CAPTCHA: {
    order: 0,
    category: "Captcha",
    reportItem: "captcha",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },
  //agb
  AGB_CONTENT_PROBLEM: {
    order: 1,
    category: "AGB",
    reportItem: "agb",
    name: "Fehlende/potenziell problematische Inhalte erkannt",
    solution:
      "In den AGB des Webshops fehlen wichtige Inhalte bzw. wurden potenziell problematische Textpassagen erkannt (siehe Thementabelle). Bitte überprüfen Sie die AGB und ziehen falls notwendig die entsprechenden Rechtsexperten zu Rate.",
  },

  //imp
  IMP_MISSING: {
    order: 2,
    category: "Impressum",
    reportItem: "imp",
    name: "Impressum fehlt",
    solution:
      "Bitte Impressum einfügen, damit User den Inhaber der Webseite identifizieren können.",
  },
  IMP_MISSING_ITEMS: {
    order: 3,
    category: "Impressum",
    reportItem: "imp",
    name: "Wichtige Inhalte fehlen im Impressum",
    solution:
      "Bitte ergänzen Sie im Impressum die fehlenden Inhalte (siehe Thementabelle).",
  },
  //forms
  FORMS_MISSING_CAPTCHA: {
    order: 0,
    category: "Webformulare",
    reportItem: "forms",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },

  FORMS_MENTION: {
    order: 1,
    category: "Webformulare",
    reportItem: "forms",
    name: "Datenverarbeitung via Webformular wird nicht erläutert",
    solution:
      "Auf der Webseite wurde mind. ein Webformular gefunden. Die Datenverarbeitung via Webformular (z.B. Kontaktseite, Newsletteranmeldung, Bewerbung für offene Stellen) muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  //security

  EXTERNAL_CONTENT_FOUND : {
    order: 0,
    category: "Extern geladete Inhalte",
    reportItem: "external-content",
    name: "Beim Laden der Webseite werden externe Inhalte wie Bilder, Applikationen oder Schriftarten geladen.",
    solution: "Bitte überprüfen Sie, ob die extern geladenen Inhalte aus seriösen Quellen stammen, kein Sicherheitsrisiko dadurch besteht und keine Urheberrechts- oder Datenschutzverletzungen begangen werden.",
  }},
  SSL_INVALID: {
    order: 0,
    category: "SSL-Zertifikat",
    reportItem: "ssl",
    name: "Es wurde ein ungültiges SSL-Zertifikat gefunden.",
    solution: "Bitte erneuern Sie das SSL-Zertifikat.",
  }
  ,
WEB_PREMIUM:{  SOFTWARE_FOUND: {
  order: 0,
  category: "Software inkl. Versionscheck",
  reportItem: "software",
  name: "Der Webserver gibt Informationen zur verwendeten Software preis.",
  solution: "Bitte konfigurieren Sie den Webserver so, dass keine bzw. möglichst wenige Informationen zur verwendeten Software nach außen sichtbar sind."
},
SOFTWARE_OUTDATED:{
  order: 0,
  category: "Software inkl. Versionscheck",
  reportItem: "software",
  name: "Auf dem Webserver verwendete Software ist veraltet.",
  solution: "Bitte führen Sie das entsprechende Update durch, um die neueste Version der Software zu verwenden.  "
},
SECURITY_FLAGS_USNAFE: { 
  order: 0,
  category: "Security Flags Cookies",
  reportItem: "security-flags",
  name: "Es wurden (potenziell) unsichere Einstellungen der Cookie Security Flags erkannt.",
  solution: "Bitte überprüfen Sie die Einstellungen der Security Flags im Kontext Ihrer Webanwendung und ändern Sie bei Bedarf die Konfiguration."},
ENCRYPTION_UNSAFE: {
  order: 0,
  category: "Verschlüsselung",
  reportItem: "encryption",
  name: "Es wurden unsichere Verschlüsselungsmethoden erkannt",
  solution: "Bitte deaktivieren/entfernen Sie die als unsicher erkannten Verschlüsselungsmethoden."

}, PHONE_EMAIL_VISIBLE:{
  order: 0,
  category: "Telefon/E-Mail sichtbar",
  reportItem: "phone-email",
  name: "Telefonnummer und/oder E-Mail Adresse stehen in Klarschrift im Impressum der Webseite. ",
  solution: "Bitte Telefonnummer und/oder E-Mail Adresse als Bilddatei anstatt in Klarschrift (=Text) ins Impressum einfügen, um das Auslesen durch Bots zu erschweren."

},SECURITY_HEADER_MISSING_HEADERS : {
  order: 0,
  category: "Security Header",
  reportItem: "security-header",
  name: "Verpflichtende/Empfohlene/Optionale Security Header fehlen. ",
  solution: "Bitte setzen Sie die entsprechenden Security Header."

},
SECURITY_HEADER_FORBIDDEN_HEADER : {
  order: 1,
  category: "Security Header",
  reportItem: "security-header",
  name: "Gewisse gefundene Security Header sollten entfernt/deaktiviert werden. ",
  solution: "Bitte entfernen/deaktivieren Sie die entsprechenden Security Header."
},
  //cookie-banner
  COOKIES_UNKNOWN_FOUND: {
    order: 0,
    category: "Cookie-Banner",
    reportItem: "cookie-banner",
    name: "Unbekannte Cookies erkannt",
    solution:
      "Bitte überprüfen Sie die Quelle und Funktion dieser Cookies und nehmen Sie diese auch in Ihre Datenschutzerklärung / Cookie-Liste auf. Sollte es sich dabei nicht um technisch notwendige Cookies handeln, müssen Sie für deren Aktivierung das Einverständnis der Webseitenbesucher einholen (durch ein Cookie-Banner).",
  },
  COOKIE_BANNER_COOKIES_WITHOUT_CONSENT: {
    order: 1,
    reportItem: "cookie-banner",
    category: "Cookie-Banner",
    name: "Cookies werden ohne Einverständnis aktiviert",
    solution:
      "Auf der Webseite werden Cookies ohne Einverständnis aktiviert (siehe Liste der Cookies). Bitte stellen Sie sicher, dass Sie vor Aktivierung der Cookies per Cookie-Banner das Einverständnis der User einholen. Vor diesem Einverständnis müssen die Cookies geblockt werden.",
  },
  COOKIE_BANNER_MISSING: {
    order: 2,
    category: "Cookie-Banner",
    reportItem: "cookie-banner",
    name: "Cookie-Banner fehlt",
    solution:
      "Auf der Webseite werden Cookies aktiviert, für deren Einsatz Sie das Einverständnis der User benötigen. Bitte fügen Sie ein Cookie-Banner ein, um dieses Einverständnis einzuholen. ",
  },
  //cookies

  COOKIE_BANNER_COOKIES_UNKNOWN_FOUND_FOUND: {
    order: 0,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Unbekannte Cookies erkannt",
    solution:
      "Bitte überprüfen Sie die Quelle und Funktion dieser Cookies und nehmen Sie diese auch in Ihre Datenschutzerklärung / Cookie-Liste auf. Sollte es sich dabei nicht um technisch notwendige Cookies handeln, müssen Sie für deren Aktivierung das Einverständnis der Webseitenbesucher einholen (durch ein Cookie-Banner).",
  },
  COOKIES_WITHOUT_CONSENT: {
    order: 1,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Cookies werden ohne Einverständnis aktiviert",
    solution:
      "Auf der Webseite werden Cookies ohne Einverständnis aktiviert (siehe Liste der Cookies). Bitte stellen Sie sicher, dass Sie vor Aktivierung der Cookies per Cookie-Banner das Einverständnis der User einholen. Vor diesem Einverständnis müssen die Cookies geblockt werden.",
  },
  COOKIES_UNLISTED_COOKIES: {
    order: 2,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },

  //DAT
  DAT_CONTENT_PROBLEM: {
    order: 0,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Fehlende/potenziell problematische Inhalte erkannt",
    solution:
      "In der Datenschutzerklärung fehlen wichtige Inhalte bzw. wurden potenziell problematische Textpassagen erkannt (siehe Thementabelle). Bitte überprüfen Sie die Datenschutzerklärung und ziehen falls notwendig die entsprechenden Rechtsexperten zu Rate.",
  },
  DAT_COOKIES_UNLISTED_COOKIES: {
    order: 1,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },
  DAT_FORMS_NOT_MENTIONED: {
    order: 2,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenverarbeitung via Webformular wird nicht erläutert",
    solution:
      "Auf der Webseite wurde mind. ein Webformular gefunden. Die Datenverarbeitung via Webformular (z.B. Kontaktseite, Newsletteranmeldung, Bewerbung für offene Stellen) muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  DAT_COOKIES_FOUND_NO_DAT: {
    order: 3,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenverarbeitung via Cookies wird nicht erläutert",
    solution:
      "Die Datenverarbeitung via Cookies muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  DAT_MISSING: {
    order: 4,
    category: "Datenschutzerklärung",
    reportItem: "dat",
    name: "Datenschutzerklärung fehlt",
    solution:
      "Bitte fügen Sie eine Datenschutzerklärung ein. Sie benötigen eine Datenschutzerklärung auf Ihrer Webseite, wenn Sie z.B. Cookies einsetzen oder Daten via Webformular (z.B. Kontaktformular) verarbeiten.",
  },
  //COK
  COK_COOKIES_UNLISTED_COOKIES: {
    order: 0,
    category: "Cookie-Richtlinie",
    reportItem: "cok",
    name: "Cookies werden nicht alle aufgelistet",
    solution:
      "Bitte listen Sie alle auf der Webseite vorhandenen Cookies entweder in der Datenschutzerklärung oder in einer separaten Cookie-Liste (Cookie-Richtlinie) auf. Alternativ können die Cookies auch direkt im Cookie-Banner aufgelistet werden.",
  },

  //agb
  AGB_CONTENT_PROBLEM: {
    order: 1,
    category: "AGB",
    reportItem: "agb",
    name: "Fehlende/potenziell problematische Inhalte erkannt",
    solution:
      "In den AGB des Webshops fehlen wichtige Inhalte bzw. wurden potenziell problematische Textpassagen erkannt (siehe Thementabelle). Bitte überprüfen Sie die AGB und ziehen falls notwendig die entsprechenden Rechtsexperten zu Rate.",
  },

  //imp
  IMP_MISSING: {
    order: 2,
    category: "Impressum",
    reportItem: "imp",
    name: "Impressum fehlt",
    solution:
      "Bitte Impressum einfügen, damit User den Inhaber der Webseite identifizieren können.",
  },
  IMP_MISSING_ITEMS: {
    order: 3,
    category: "Impressum",
    reportItem: "imp",
    name: "Wichtige Inhalte fehlen im Impressum",
    solution:
      "Bitte ergänzen Sie im Impressum die fehlenden Inhalte (siehe Thementabelle).",
  },
  //forms
  FORMS_MISSING_CAPTCHA: {
    order: 0,
    category: "Webformulare",
    reportItem: "forms",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },
  FORMS_MENTION: {
    order: 1,
    category: "Webformulare",
    reportItem: "forms",
    name: "Datenverarbeitung via Webformular wird nicht erläutert",
    solution:
      "Auf der Webseite wurde mind. ein Webformular gefunden. Die Datenverarbeitung via Webformular (z.B. Kontaktseite, Newsletteranmeldung, Bewerbung für offene Stellen) muss in der Datenschutzerklärung erläutert werden; bitte ergänzen Sie dies in der Datenschutzerklärung.",
  },
  //security
  SSL_INVALID: {
    order: 0,
    category: "SSL-Zertifikat",
    reportItem: "ssl",
    name: "Es wurde ein ungültiges SSL-Zertifikat gefunden.",
    solution: "Bitte erneuern Sie das SSL-Zertifikat.",
  }
  ,
  EXTERNAL_CONTENT_FOUND : {
    order: 0,
    category: "Extern geladete Inhalte",
    reportItem: "external-content",
    name: "Beim Laden der Webseite werden externe Inhalte wie Bilder, Applikationen oder Schriftarten geladen.",
    solution: "Bitte überprüfen Sie, ob die extern geladenen Inhalte aus seriösen Quellen stammen, kein Sicherheitsrisiko dadurch besteht und keine Urheberrechts- oder Datenschutzverletzungen begangen werden.",
  },
  CAPTCHA_FORM_WITHOUT_CAPTCHA: {
    order: 0,
    category: "Captcha",
    reportItem: "captcha",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },},
WEB_SWISS:SWISS_TO_DO_ITEMS,
WEB_SWISS_2:SWISS_TO_DO_ITEMS,

WEB_SECURITY:{ 
  SOFTWARE_FOUND: {
    order: 0,
    category: "Software inkl. Versionscheck",
    reportItem: "software",
    name: "Der Webserver gibt Informationen zur verwendeten Software preis.",
    solution: "Bitte konfigurieren Sie den Webserver so, dass keine bzw. möglichst wenige Informationen zur verwendeten Software nach außen sichtbar sind."
  },
  SOFTWARE_OUTDATED:{
    order: 0,
    category: "Software inkl. Versionscheck",
    reportItem: "software",
    name: "Auf dem Webserver verwendete Software ist veraltet.",
    solution: "Bitte führen Sie das entsprechende Update durch, um die neueste Version der Software zu verwenden.  "
  },
  SECURITY_FLAGS_USNAFE: { 
    order: 0,
    category: "Security Flags Cookies",
    reportItem: "security-flags",
    name: "Es wurden (potenziell) unsichere Einstellungen der Cookie Security Flags erkannt.",
    solution: "Bitte überprüfen Sie die Einstellungen der Security Flags im Kontext Ihrer Webanwendung und ändern Sie bei Bedarf die Konfiguration."},
  ENCRYPTION_UNSAFE: {
    order: 0,
    category: "Verschlüsselung",
    reportItem: "encryption",
    name: "Es wurden unsichere Verschlüsselungsmethoden erkannt",
    solution: "Bitte deaktivieren/entfernen Sie die als unsicher erkannten Verschlüsselungsmethoden."
  
  },
  PHONE_EMAIL_VISIBLE:{
  order: 0,
  category: "Telefon/E-Mail sichtbar",
  reportItem: "phone-email",
  name: "Telefonnummer und/oder E-Mail Adresse stehen in Klarschrift im Impressum der Webseite. ",
  solution: "Bitte Telefonnummer und/oder E-Mail Adresse als Bilddatei anstatt in Klarschrift (=Text) ins Impressum einfügen, um das Auslesen durch Bots zu erschweren."

},
  SECURITY_HEADER_MISSING_HEADERS : {
    order: 0,
    category: "Security Header",
    reportItem: "security-header",
    name: "Verpflichtende/Empfohlene/Optionale Security Header fehlen. ",
    solution: "Bitte setzen Sie die entsprechenden Security Header."
  
  },
  SECURITY_HEADER_FORBIDDEN_HEADER : {
    order: 1,
    category: "Security Header",
    reportItem: "security-header",
    name: "Gewisse gefundene Security Header sollten entfernt/deaktiviert werden. ",
    solution: "Bitte entfernen/deaktivieren Sie die entsprechenden Security Header."
  },

  //cookie-banner
  COOKIES_UNKNOWN_FOUND:null,
  COOKIE_BANNER_COOKIES_WITHOUT_CONSENT: null,
  COOKIE_BANNER_MISSING: null,
  //cookies

  COOKIE_BANNER_COOKIES_UNKNOWN_FOUND_FOUND: {
    order: 0,
    category: "Cookies",
    reportItem: "cookie-check",
    name: "Unbekannte Cookies erkannt",
    solution:
      "Bitte überprüfen Sie die Quelle und Funktion dieser Cookies und nehmen Sie diese auch in Ihre Datenschutzerklärung / Cookie-Liste auf. Sollte es sich dabei nicht um technisch notwendige Cookies handeln, müssen Sie für deren Aktivierung das Einverständnis der Webseitenbesucher einholen (durch ein Cookie-Banner).",
  },
  COOKIES_WITHOUT_CONSENT: null,
  COOKIES_UNLISTED_COOKIES: null,

  //DAT
  DAT_CONTENT_PROBLEM: null,
  DAT_COOKIES_UNLISTED_COOKIES: null,
  DAT_FORMS_NOT_MENTIONED: null,
  DAT_COOKIES_FOUND_NO_DAT: null,
  DAT_MISSING: null,
  //COK
  COK_COOKIES_UNLISTED_COOKIES:null,

  //agb
  AGB_CONTENT_PROBLEM: null,

  //imp
  IMP_MISSING: null,
  IMP_MISSING_ITEMS: null,
  //forms
  FORMS_MISSING_CAPTCHA: null,
  FORMS_MENTION:null,
  //security
  SSL_INVALID: {
    order: 0,
    category: "SSL-Zertifikat",
    reportItem: "ssl",
    name: "Es wurde ein ungültiges SSL-Zertifikat gefunden.",
    solution: "Bitte erneuern Sie das SSL-Zertifikat.",
  },
  EXTERNAL_CONTENT_FOUND : {
    order: 0,
    category: "Extern geladete Inhalte",
    reportItem: "external-content",
    name: "Beim Laden der Webseite werden externe Inhalte wie Bilder, Applikationen oder Schriftarten geladen.",
    solution: "Bitte überprüfen Sie, ob die extern geladenen Inhalte aus seriösen Quellen stammen, kein Sicherheitsrisiko dadurch besteht und keine Urheberrechts- oder Datenschutzverletzungen begangen werden.",
  }
  ,
  CAPTCHA_FORM_WITHOUT_CAPTCHA: {
    order: 0,
    category: "Captcha",
    reportItem: "captcha",
    name: "Min. ein Webformular hat kein Captcha",
    solution:
      "Um DOS-Attacken vorzubeugen, sollten Webformulare durch ein Captcha geschützt werden. Bitte fügen Sie bei jedem Webformular ein entsprechendes Captcha ein.",
  },
},


}
;
export const REPORT_DEFAULT_ITEM_ORDER = "suggestions,details,information";
 
 
export const formTypes = [{
    value :"newsletter",
    label: "Newsletter"},
    {value:"jobs",
    label:"Jobs/Karriere/Bewerbung"},
    {value :"booking",
    label: "Reservierung/Buchung"},
    {value:"contact",
    label: "Kontakt"},
    {value :"home",
    label: "Unbekannt"}

];
